import React from "react";
import { ImSpinner9 } from "react-icons/im";

export default function LoadingCM({ title = "" }) {
  return (
    <div className="mt-5 m-auto !font-dana-bold w-max my-10  flex flex-col rounded-xl justify-center items-center bg-white p-32 font-kalameh !text-4xl max-[800px]:p-4 max-[800px]:w-full max-[600px]:text-xl absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
      <div className=" text-center text-secondary-400 items-center gap-3 flex flex-col">
        <ImSpinner9 className="animate-spin" fontSize={48} />
        {title}
      </div>
    </div>
  );
}
